import { AxiosInstance } from 'axios';
import {
    MaintenanceItemEdit,
    MaintenanceItemAdd,
    MaintenanceListResponse,
    MaintenanceCompletionRequest,
} from 'models/api/maintenance';
import Id from 'models/id';
import { Pagination } from 'models/common';
import { Platform } from 'models/api/platform';

const controller = '/maintenance'

export const setEmergencyMaintenance = async (axios: AxiosInstance) => {
  const { data } = await axios.post<null>(controller + '/emergency', {
    platform: Platform.All,
    reason: 'Emergency maintenance',
  });
    return data;
};

export const getMaintenanceList = async (axios: AxiosInstance, params: Pagination) => {
    const { data } = await axios.get<MaintenanceListResponse>(controller, { params });
      return data;
};

export const createMaintenance = async (axios: AxiosInstance, item: MaintenanceItemAdd) =>
    await axios.post<Id>(controller + '/planning', item);

export const updateMaintenance = async (axios: AxiosInstance, item: MaintenanceItemEdit) =>
    await axios.put<null>(controller + `/${item.id}`, item);

export const cancelMaintenance = async (axios: AxiosInstance, id: string) =>
    await axios.post<null>(controller + `/cancellation/${id}`);

export const completeMaintenance = async (axios: AxiosInstance, item: MaintenanceCompletionRequest) =>
    await axios.patch<null>(controller + `/completion`, item);

export const deleteMaintenance = async (axios: AxiosInstance, id: string) =>
    await axios.delete<null>(controller + `/${id}`);